export enum CommandName {
    // BULK
    BULK = 'bulk',

    // PROJECT
    CREATE_PROJECT = 'create.project',
    UPDATE_PROJECT = "update.project",
    DELETE_PROJECT = "delete.project",

    // ISSUE
    CREATE_ISSUE = 'create.issue',
    UPDATE_ISSUE = "update.issue",
    DELETE_ISSUE = "delete.issue",
    FINALIZE_ISSUE = "finalize.issue",

    // EMPLOYEE
    CREATE_EMPLOYEE = 'create.employee',
    RENAME_EMPLOYEE = 'rename.employee',
    DELETE_EMPLOYEE = 'delete.employee',

    // KEYWORD
    CREATE_KEYWORD = 'create.keyword',
    RENAME_KEYWORD = 'rename.keyword',
    RECOLOR_KEYWORD = 'recolor.keyword',
    DELETE_KEYWORD = 'delete.keyword',

    // KNOWLEDGE OBJECT
    CREATE_KNOWLEDGE_OBJECT = 'create.knowledge-object',
    UPDATE_KNOWLEDGE_OBJECT_METADATA = 'update.knowledge-object-metadata',
    SAVE_KNOWLEDGE_OBJECT_CONTENT = 'save.knowledge-object-content',
    DELETE_KNOWLEDGE_OBJECT = 'delete.knowledge-object',

    // ISSUE STATUS
    CREATE_ISSUE_STATUS = 'create.issue-status',
    RENAME_ISSUE_STATUS = 'rename.issue-status',
    RECOLOR_ISSUE_STATUS = 'recolor.issue-status',
    REORDER_ISSUE_STATUS = 'reorder.issue-status',
    DELETE_ISSUE_STATUS = 'delete.issue-status',

    // ISSUE TYPE
    CREATE_ISSUE_TYPE = 'create.issue-type',
    UPDATE_ISSUE_TYPE = 'update.issue-type',
    DELETE_ISSUE_TYPE = 'delete.issue-type',

    // WEEKLY WORKING TIME
    CREATE_WEEKLY_WORKING_TIME = 'create.weekly-working-time',
    UPDATE_WEEKLY_WORKING_TIME = 'update.weekly-working-time',

    // EMPLOYEE TO ISSUE ASSIGNMENT
    DELETE_EMPLOYEE_TO_ISSUE_ASSIGNMENT = 'delete.employee-to-issue-assignment',
    CREATE_EMPLOYEE_TO_ISSUE_ASSIGNMENT = 'create.employee-to-issue-assignment',
    UPDATE_EMPLOYEE_TO_ISSUE_ASSIGNMENT = 'update.employee-to-issue-assignment',

    // PERSONAL LABEL
    CREATE_PERSONAL_LABEL = 'create.personal-label',
    UPDATE_PERSONAL_LABEL = 'update.personal-label',
    DELETE_PERSONAL_LABEL = 'delete.personal-label',

    // ISSUE PERSONAL DATA
    CREATE_ISSUE_PERSONAL_DATA = 'create.issue-personal-data',
    UPDATE_ISSUE_PERSONAL_DATA = 'update.issue-personal-data',
    DELETE_ISSUE_PERSONAL_DATA = 'delete.issue-personal-data',
    ASSIGN_ISSUE_TO_PERSONAL_LABEL = 'assign.issue-to-personal-label',
    UNASSIGN_ISSUE_FROM_PERSONAL_LABEL = 'unassign.issue-from-personal-label',
    MOVE_ISSUE_TO_ANOTHER_PERSONAL_LABEL = 'move.issue-to-another-personal-label',
    REORDER_ISSUE_OF_PERSONAL_LABEL = 'reorder.issue-of-personal-label',

    // UI ACTIONS
    CLEAR_FILTERS = 'clear.filters',
    TIMELINE_JUMP_TO_DATE = 'timeline.jump-to-date',
    TIMELINE_TOGGLE_WEEKLY_VIEW = 'timeline.toggle-weekly-view',
    TASKLIST_TOGGLE_VIEW = 'tasklist.toggle-view',

    // UI ACTIONS - OPEN DIALOGS
    OPEN_NEW_ISSUE_DIALOG = 'open.new-issue-dialog',
    OPEN_NEW_PROJECT_DIALOG = 'open.new-project-dialog',
    OPEN_NEW_DAILY_DIALOG = 'open.new-daily-dialog',
    OPEN_NEW_EMPLOYEE_DIALOG = 'open.new-employee-dialog',
    OPEN_NEW_KEYWORD_DIALOG = 'open.new-keyword-dialog',
    OPEN_NEW_ISSUE_TYPE_DIALOG = 'open.new-issue-type-dialog',
    
    // APPLICATION ACTIONS
    EXPORT_ICAL_CURRENT_YEAR = 'export.ical-current-year',
    LOGOUT = 'logout',

    // TRANSLATION OVERRIDE (O2D-PRD-092; value mirrors backend CommandInterface.php:66)
    SAVE_TRANSLATION_OVERRIDE = 'save.translation-override',

    // TENANT THEME (feature plan 0054; value mirrors backend CommandInterface::SAVE_TENANT_THEME)
    SAVE_TENANT_THEME = 'save.tenant-theme',

    // TENANT SETTINGS (feature plan 0068; value mirrors backend CommandInterface::SAVE_TENANT_SETTINGS)
    SAVE_TENANT_SETTINGS = 'save.tenant-settings',

    // OWN PROFILE (settings page "Mein Profil"; values mirror backend CommandInterface)
    UPDATE_USER = 'update.user',
    CHANGE_OWN_EMAIL_ADDRESS = 'change.own-email-address',
    CHANGE_OWN_PASSWORD = 'change.own-password',
    /** Revokes one of the logged-in user's own API tokens; creating one goes through POST /api/v1/me/api-tokens. */
    REVOKE_API_TOKEN = 'revoke.api-token',

    // RESTORE (O2D-PRD-101; value mirrors backend CommandInterface::RESTORE_ENTITY)
    RESTORE_ENTITY = 'restore.entity',

    // LINKVIEW (O2D-PRD-111; values mirror backend CommandInterface::CREATE_LINKVIEW ff.)
    // The backend turns `<verb>.<kebab-entity>` into a class name by pure string
    // transformation, so these strings ARE the contract — and each carries
    // exactly one dot, because the split there keeps two parts and discards the
    // rest. `linkview` is one word with a lowercase `v`.
    CREATE_LINKVIEW = 'create.linkview',
    RENAME_LINKVIEW = 'rename.linkview',
    DELETE_LINKVIEW = 'delete.linkview',
    CREATE_LINK_TILE = 'create.link-tile',
    UPDATE_LINK_TILE = 'update.link-tile',
    DELETE_LINK_TILE = 'delete.link-tile',
    REORDER_LINK_TILE = 'reorder.link-tile',

    // ENTITY EDIT LOCK (O2D-PRD-110; values mirror backend
    // CommandInterface::LOCK_ENTITY ff.). Entity-agnostic on purpose: the target
    // is named by the payload's `entityType`, whitelisted server-side, so no
    // class name is ever built from client input. The type key itself lives in
    // `lockable-entity-type.constant.ts`.
    //
    // Each carries exactly one dot, because the backend split keeps two parts
    // and discards the rest — `override.entity.lock` would silently resolve to
    // `OverrideEntityCommand`.
    LOCK_ENTITY = 'lock.entity',
    RELEASE_ENTITY_LOCK = 'release.entity-lock',
    OVERRIDE_ENTITY_LOCK = 'override.entity-lock',
}